export default __webpack_public_path__ + "static/media/NP50.9704fde0.jpg";